// products
export const PUT_PRODUCT = 'putProduct'

// productsStats
export const PUT_PRODUCT_STATS = 'putProductStats'

// acquisitions
export const PROCESS_ACQUISITIONS = 'processAcquisitions'
export const COMPLETE_ACQUISITION = 'completeAcquisition'
export const PUT_ACQUISITION = 'putAcquisition'
export const UPDATE_ACQUISITION_IN_STOCK_COUNT = 'updateAcquisitionInStockCount'
export const DELETE_TO_BUY_ITEM = 'deleteToBuyItem'
export const SELL_ACQUISITIONS = 'sellAcquisitions'
export const RETURN_ACQUISITIONS = 'returnAcquisitions'

// budget
export const RECOMPUTE_BUDGET = 'recomputeBudget'
export const PUT_BUDGET = 'putBudget'

// cashboxHistory
export const UPDATE_CASHBOX = 'updateCashbox'
export const PUT_CASHBOX_OPERATION = 'putCashboxOperation'

// sale
export const PUT_SALE = 'putSale'
export const DELETE_SALE_ITEM = 'deleteSaleItem'
export const PROCESS_SALE = 'processSale'
export const PROCESS_RETURN_ITEMS = 'processReturnItems'

// stats
export const PUT_STAT = 'putStat'

// users
export const PUT_USER = 'putUser'
export const PUT_OWNER_USER = 'putOwnerUser'

// usersStats
export const PUT_USER_STATS = 'putUserStats'

// groups
export const PUT_GROUP = 'putGroup'

// suppliers
export const PUT_SUPPLIER = 'putSupplier'

// suppliersStats
export const PUT_SUPPLIER_STATS = 'putSupplierStats'

// customers
export const PUT_CUSTOMER = 'putCustomer'

// customersStats
export const PUT_CUSTOMER_STATS = 'putCustomerStats'

// carts
export const PUT_CART = 'putCart'
export const ADD_CART = 'addCart'
export const REMOVE_CART = 'removeCart'
export const PUT_CART_PARTICIPANTS = 'putCartParticipants'

// stickers
export const PUT_STICKER = 'putSticker'
export const PUT_STICKERS_SELECTION_ITEM = 'putStickersSelectionItem'
export const DELETE_STICKERS_SELECTION = 'deleteStickersSelection'
export const DELETE_STICKERS_SELECTION_ITEM = 'deleteStickersSelectionItem'
